import React from 'react';

import styles from './NoColorBackdrop.module.scss';

const nocolorbackdrop = (props) => (
  props.show ? <div className={styles.NoColorBackdrop} onClick={props.clicked}></div>: null
);

export default nocolorbackdrop;